export const data = [
  {
    id: '1',
    company: 'Consórcio Genial',
    creditValue: 1000000,
    adminFee: 24,
    installments: 219,
    installmentValue: 5662.1,
  },
  {
    id: '2',
    company: 'Consórcio Avançado',
    creditValue: 1500000,
    adminFee: 22,
    installments: 240,
    installmentValue: 7890.5,
  },
  {
    id: '3',
    company: 'Consórcio Elite',
    creditValue: 2000000,
    adminFee: 20,
    installments: 260,
    installmentValue: 9876.54,
  },
  {
    id: '4',
    company: 'Consórcio Popular',
    creditValue: 750000,
    adminFee: 26,
    installments: 200,
    installmentValue: 4321.0,
  },
  {
    id: '5',
    company: 'Consórcio Adaptável',
    creditValue: 1250000,
    adminFee: 23,
    installments: 230,
    installmentValue: 6543.21,
  },
];
